import { heroCover } from "@/mocks/manga";

const stats = [
  { value: "4.8万+", label: "部连载作品" },
  { value: "960万+", label: "追更读者" },
  { value: "每日", label: "榜单实时刷新" },
];

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroCover}
          alt="番木瓜漫画追更平台背景插画"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-20 pt-32 text-center md:px-6 md:pb-28 md:pt-40">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 ring-1 ring-background-50/30 backdrop-blur-sm">
          <i className="ri-fire-line"></i>
          人气连载 · 追更进度条 · 热门榜单
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl leading-tight text-background-50 md:text-5xl">
          番木瓜漫画
          <span className="mt-2 block text-xl md:text-3xl">人气连载与霸榜作品的追更乐园</span>
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
          追更进度条实时同步，热门榜单每日刷新，长期连载不怕断。点开即知最新话进度，每一部想追的漫画都不会错过更新。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#serial"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-base font-medium text-background-50 transition-colors hover:bg-primary-400 sm:w-auto"
          >
            <i className="ri-play-circle-fill mr-2"></i>
            去追更
          </a>
          <a
            href="#ranking"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-background-50/15 px-6 py-3 text-base text-background-50 ring-1 ring-background-50/40 backdrop-blur-sm transition-colors hover:bg-background-50/25 sm:w-auto"
          >
            <i className="ri-trophy-line mr-2"></i>
            查看热门榜单
          </a>
        </div>

        <div className="mt-12 grid w-full max-w-2xl grid-cols-1 gap-3 sm:grid-cols-3">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-background-50/10 px-4 py-4 text-center ring-1 ring-background-50/20 backdrop-blur-sm"
            >
              <p className="font-heading text-2xl text-accent-300 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-sm text-background-100/90">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}